export default __webpack_public_path__ + "static/services-detailsbi-092666d072a4b3e8ffa0336ebb249cb3.jpg";